// src/hooks/useProjectDrilldown.js
import { useState, useEffect, useCallback } from "react";
import { getProjectDrilldown } from "../../api/dashboardApi";

export default function useProjectDrilldown(projectId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDrilldown = useCallback(async () => {
    if (!projectId) {
      setError("Project ID is required");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const result = await getProjectDrilldown(projectId);
      setData(result);
      return { success: true, data: result };
    } catch (err) {
      console.error("Failed to fetch drilldown data:", err);
      setError(err.message || "Failed to load project drilldown");
      return { success: false, error: err };
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  // Auto fetch when projectId changes
  useEffect(() => {
    fetchDrilldown();
  }, [fetchDrilldown]);

  return {
    data,
    loading,
    error,
    fetchDrilldown,
  };
}